// Reglas del nombre y los apellidos de una persona: espejo exacto de PersonNameRules del backend
// (IroniaBackendCore/UserIdentities/Rules/PersonNameRules.cs). Si cambia una, hay que cambiar la otra.
//
// Un nombre solo puede llevar letras (con tildes y diéresis), espacios, guiones y apóstrofos, y tiene que
// empezar y acabar por letra. Lo inofensivo (lo que deja el OCR del DNI o el teclado) se limpia; lo demás
// (dígitos, < >, puntos, símbolos...) no es válido. Las letras son las que caben en las columnas varchar
// del backend (página de códigos 1252): una "Ł" se guardaría como "?".

export const PersonNameMaxLength = 50;

export const PersonNameInvalidMessage = "Solo letras, espacios, guiones y apóstrofos; debe empezar y terminar por una letra.";

const LetterClass = "A-Za-zÀ-ÖØ-öø-ÿŠšŽžŒœŸª";
const ValidNamePattern = new RegExp(`^[${LetterClass}]+(?:[ '\\-][${LetterClass}]+)*$`);

/**
 * Limpia lo inofensivo de un nombre sin validarlo: unifica espacios, guiones y apóstrofos, quita los
 * espacios que los rodean, colapsa los repetidos y elimina los separadores de los extremos.
 */
export const normalizePersonName = (value: string | null | undefined): string =>
{
    if(value === null || value === undefined)
    {
        return "";
    }

    return value
        .normalize("NFC")
        .replace(/\s+/g, " ")
        .replace(/[‐-―−­]/g, "-")
        .replace(/[‘’‛´`ʼ]/g, "'")
        .replace(/ *([-']) */g, "$1")
        .replace(/-{2,}/g, "-")
        .replace(/'{2,}/g, "'")
        .replace(/^[ '-]+|[ '-]+$/g, "");
};

/**
 * Indica si el nombre, una vez limpio, cumple el formato y cabe en la columna. Vacío no es válido.
 */
export const isValidPersonName = (value: string | null | undefined): boolean =>
{
    const normalized = normalizePersonName(value);
    return normalized.length > 0 && normalized.length <= PersonNameMaxLength && ValidNamePattern.test(normalized);
};
